// Frontend view of the backend speech-processing relay (POST /v1/core/speech-processing/transcribe).
// Mirrors the response assembled in missionsquad-api/src/controllers/speechProcessing.ts, which
// forwards rosetta-ai's TranscriptionResult fields — segments/words are provider-shaped, so unknown[].

export interface SpeechTranscriptionResponse {
  success: boolean
  text: string
  model: string
  /** Language detected or used (ISO-639-1). Provided by some models/modes. */
  language?: string
  /** Duration of the audio processed in seconds. Provided by some models/modes. */
  duration?: number
  /** Segment-level details; structure varies by provider and response format. */
  segments?: unknown[]
  /** Word-level timestamps; structure varies by provider and response format. */
  words?: unknown[]
}

export function isSpeechTranscriptionResponse(value: unknown): value is SpeechTranscriptionResponse {
  if (value == null || typeof value !== 'object') return false
  const candidate = value as Record<string, unknown>
  return candidate.success === true && typeof candidate.text === 'string' && typeof candidate.model === 'string'
}
